import {
defineCustomElement,
MediaVolumeSliderElement,
MediaSliderValueElement
} from "vidstack/elements";

defineCustomElement(MediaVolumeSliderElement);
defineCustomElement(MediaSliderValueElement);